'use client'

import { type ReactNode } from 'react'
import { ChevronUp } from 'lucide-react'
import { isPageScrolledStore } from '@/components/Law/Clause/scroll-store'
import { Row, Stack } from '@christiankaindl/lyts'
import { desktop, theme } from '@/styles/theme.css'
import Button from '@/components/Button/Button'
import { useStore } from '@/lib/store/store'
import { useScrollbarOffset } from '@/hooks/useScrollLock'
import { writable } from 'svelte/store'
import { Overlay, OverlayContent } from '@/components/Overlay'

export function BottomRight ({ children }: { children: ReactNode }) {
  const scrollbarOffset = useScrollbarOffset()
  return (
    <Row
      style={{
        position: 'fixed',
        right: `calc(1em + ${scrollbarOffset}px)`,
        bottom: '1em',
      }}
    >
      {children}
    </Row>
  )
}
interface InfoOverlayProps {
  children: ReactNode
  title: string
}
export const infoOverlayStore = writable({ isOpen: false })
export function InfoOverlay ({ children, title }: InfoOverlayProps) {
  const { isOpen } = useStore(infoOverlayStore)

  return (
    <Overlay open={isOpen} setOpen={(isOpen) => { infoOverlayStore.set({ isOpen }) }}>
      <OverlayContent
        title='Details'
        description={title}
      >
        <Stack>
          {children}
        </Stack>
      </OverlayContent>
    </Overlay>

  )
}
export function ScrollToTopButton () {
  function scrollToTop (): void {
    // TODO: Also remove any hash part?
    window.scrollTo({ top: 0 })
  }
  const show = useStore(isPageScrolledStore)
  if (!show) {
    return null
  }
  return (
    <div
      className={desktop}
      style={{
        backgroundColor: theme.colors.backgrounds.bg5,
        display: 'flex',
        borderRadius: 7,
        width: 45,
      }}
    >
      <Button
        size='large'
        title='Zum Seitenanfang'
        square
        circular
        onClick={scrollToTop}
        variant='flat'
        style={{
          // Fix weird edge-case in Safari where there is 2px margin for some reason...
          margin: 0,
        }}
      >
        <ChevronUp size={20} />
      </Button>
    </div>
  )
}
